import request, { ApiResponse } from './request';

export interface SaleFormData {
  customer_id: number;
  category_id: number;
  price_level_id: number;
  weight: number;
  sale_time?: string;
  note?: string;
}

export function createSale(data: SaleFormData): Promise<ApiResponse<any>> {
  return request.post('/sales', data);
}

export function updateSale(id: number, data: SaleFormData): Promise<ApiResponse<any>> {
  return request.put(`/sales/${id}`, data);
}

export function deleteSale(id: number): Promise<ApiResponse<null>> {
  return request.delete(`/sales/${id}`);
}

export function getSale(id: number): Promise<ApiResponse<any>> {
  return request.get(`/sales/${id}`);
}

export function getSales(params?: {
  customer_id?: number;
  start_date?: string;
  end_date?: string;
  limit?: number;
}): Promise<ApiResponse<any[]>> {
  return request.get('/sales', { params });
}
